import { render } from "./AlramConfirm.vue?vue&type=template&id=54f0a17d&scoped=true"
import script from "./AlramConfirm.vue?vue&type=script&lang=js"
export * from "./AlramConfirm.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=54f0a17d&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=54f0a17d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f0a17d"]])

export default __exports__